import { SvgIcon, type SvgIconProps } from './svgIcon'

export function TransactionIcon({
  width = 24,
  height = 24,
  ...props
}: SvgIconProps) {
  return (
    <SvgIcon width={width} height={height} viewBox="0 0 19 22" {...props}>
      <path
        d="M11.65 11.04L16.67 6.02M16.67 6.02L11.65 1M16.67 6.02H0.890015M6.83002 11.36L1.81001 16.38M1.81001 16.38L6.83002 21.4M1.81001 16.38H17.58"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </SvgIcon>
  )
}
